<script lang="ts">
	import { push, location } from 'svelte-spa-router';
	import { format } from 'svelte-i18n';
	import { Button, ButtonGroup, Token } from '@Shelly/shelly-design-system';
	import { setSidePanelState } from 'src/components/Sidepanel/sidepanel-helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	$: roomId = $location.split('/')[3];
	$: roomListType = $location.split('/')[4];
	$: tabs = roomId === '-10' ? ['devices'] : ['devices', 'groups', 'scenes', 'thermostats'];

	const changeRoomListType = (type) => {
		setSidePanelState({ type: 'room', id: roomId });
		push(`/home/room/${roomId}/${type}`);
	};
</script>

<!-- // TODO If info icon stays, add utility classes and fix grid gap in toolbar when right slot is hidden-->
{#if $showNewLayout}
	{#each tabs as tab, i}
		<Token
			id="tkn-{i}-3"
			size="m"
			selected={tab === roomListType}
			title={capFirstChar($format(`tab_${tab}`, { default: tab }))}
			on:click={() => {
				changeRoomListType(tab);
			}}
		/>
	{/each}
{:else}
	<ButtonGroup
		id="buttongroup-rti56qh"
		aria-label={$format('label_room_tabs', { default: 'Room tabs' })}
		noWrap
		styleType="body-extra-small"
		class="d-flex justify-content-start"
	>
		{#each tabs as tab}
			<Button
				class={classMap({
					active: tab === roomListType,
					'text-capitalize': true,
				})}
				size="m"
				on:click={() => changeRoomListType(tab)}
			>
				{$format(`tab_${tab}`, { default: tab })}
			</Button>
		{/each}
	</ButtonGroup>
{/if}
